import { Component, inject, input, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { CheckboxComponent, InputComponent, TooltipModule } from '@libs/ui-lib';
import { TranslateModule } from '@ngx-translate/core';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { ReactiveFormsModule } from '@angular/forms';
import { SiteSetupComponentService } from '../../../site-setup/site-setup.component.service';

@Component({
  selector: 'lib-license-agreement-signer-form',
  imports: [
    CommonModule,
    SvgIconComponent,
    InputComponent,
    TranslateModule,
    CdkAccordionModule,
    ReactiveFormsModule,
    TooltipModule,
    CheckboxComponent,
  ],
  templateUrl: './license-agreement-signer-form.component.html',
  styleUrl: './license-agreement-signer-form.component.scss',
})
export class LicenseAgreementSignerFormComponent {
  private readonly siteSetupComponentService = inject(SiteSetupComponentService);
  public vm = this.siteSetupComponentService.viewModel;
  public authorizedCheckboxFormControl = this.siteSetupComponentService.licenseAgreementForm.controls.confirmAuthorized;

  @Input() public showSignerEmail: boolean = false;

  public showAuthorizedCheckbox = input<boolean>(false);

  public licenseAgreementForm = this.siteSetupComponentService.getLicenseAgreementForm();
}
